// Components
const TheHeader = () => import(/* webpackPrefetch: true, webpackChunkName: 'the-header' */ '@/app/views/main-view/_shared/the-header/the-header.vue');
const TheSidebar = () => import(/* webpackPrefetch: true, webpackChunkName: 'the-sidebar' */ '@/app/views/main-view/_shared/the-sidebar/the-sidebar.vue');
const TheFooter = () => import(/* webpackPrefetch: true, webpackChunkName: 'the-footer' */ '@/app/views/main-view/_shared/the-footer/the-footer.vue');

// Event Bus
import EventBus from '@/app/bus/event-bus.js';

export default {
	name: 'MainView',
	components: {
		TheHeader,
		TheSidebar,
		TheFooter
	},
	data() {
		return {
			hasMenuMargin: false,
			isAppFixed: false
		}
	},
	created() {
		EventBus.$on('addMenuMargin', hasMenuMargin => {
			this.hasMenuMargin = hasMenuMargin;
		});

		EventBus.$on('makeAppFixed', isAppFixed => {
			this.isAppFixed = isAppFixed;
		});
	},
	beforeDestroy() {
		EventBus.$off('addMenuMargin', hasMenuMargin => {
			this.hasMenuMargin = hasMenuMargin;
		});
	}
}